"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _RateCardTableRow = _interopRequireDefault(require("./molecules/RateCardTableRow"));

var _RateCardTableHead = _interopRequireDefault(require("./molecules/RateCardTableHead"));

var _intl = require("../../intl");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tittle = /*#__PURE__*/(0, _styledComponents["default"])(_core.Typography).withConfig({
  displayName: "RateCardTable__Tittle"
})(["", ""], function (_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      palette = _ref$theme.palette;
  return (0, _styledComponents.css)(["padding:", ";background-color:", ""], spacing(2, 2, 0, 2), palette.grey[50]);
});
var ExtraInfo = /*#__PURE__*/(0, _styledComponents["default"])(_core.Typography).withConfig({
  displayName: "RateCardTable__ExtraInfo"
})(["", ""], function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return (0, _styledComponents.css)(["padding-top:", ";"], spacing(2));
});
var EmptyState = /*#__PURE__*/(0, _styledComponents["default"])(_core.Typography).withConfig({
  displayName: "RateCardTable__EmptyState"
})(["", ""], function (_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      palette = _ref3$theme.palette;
  return (0, _styledComponents.css)(["padding:", ";background-color:", ";width:100%"], spacing(2), palette.grey[50]);
});

var RateCardTable = function RateCardTable(_ref4) {
  var rates = _ref4.rates,
      currencySymbol = _ref4.currencySymbol,
      title = _ref4.title,
      type = _ref4.type,
      rest = _objectWithoutProperties(_ref4, ["rates", "currencySymbol", "title", "type"]);

  return _react["default"].createElement("div", rest, _react["default"].createElement(Tittle, {
    variant: "caption",
    color: "primary",
    component: "div"
  }, title), _react["default"].createElement(_core.Grid, {
    container: true
  }, rates.length !== 0 ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, _react["default"].createElement(_RateCardTableHead["default"], {
    type: type
  })), _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, _react["default"].createElement(_core.Grid, {
    container: true
  }, rates.map(function (rate) {
    return _react["default"].createElement(_RateCardTableRow["default"], _extends({
      key: rate.name + rate.amount,
      currencySymbol: currencySymbol,
      type: type
    }, rate));
  })))) : _react["default"].createElement(EmptyState, {
    variant: "caption",
    component: "div"
  }, _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.globalTable.emptyState"
  })), _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, _react["default"].createElement(ExtraInfo, {
    variant: "body1"
  }, _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.globalTable.extraInfo"
  })))));
};

RateCardTable.propTypes = {
  rates: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    amount: _propTypes["default"].oneOfType([_propTypes["default"].string.isRequired, _propTypes["default"].number.isRequired]),
    markupPercentage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    name: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].string
  })),
  currencySymbol: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].oneOf(['time-rate-card', 'expense-rate-card']),
  title: _propTypes["default"].string.isRequired
};
RateCardTable.defaultProps = {
  rates: [],
  currencySymbol: '&euro;',
  type: 'time-rate-card',
  title: ''
};
var _default = RateCardTable;
exports["default"] = _default;